import { atom } from 'jotai';

import type { ComplimentaryTrialEndEntryPoint } from '../../../contracts/complimentary-trial-end-analytics.types';

/** The T-7 modal is open while this names where it was opened from. */
export const complimentaryTrialEndModalEntryPointAtom =
  atom<ComplimentaryTrialEndEntryPoint | null>(null);
